export interface AlertOption {
    name: string;
    value: string;
};